import styled from 'styled-components';

export default styled.div`
  max-width: 60em;
  margin: 0 auto;
  padding: 1em;
`;
